import { render } from "./NewSendOut.vue?vue&type=template&id=a96248c4"
import script from "./NewSendOut.vue?vue&type=script&lang=js"
export * from "./NewSendOut.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/sendOuts/NewSendOut.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a96248c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a96248c4', __exports__)) {
    console.log('reload')
    api.reload('a96248c4', __exports__)
  }
  
  module.hot.accept("./NewSendOut.vue?vue&type=template&id=a96248c4", () => {
    console.log('re-render')
    api.rerender('a96248c4', render)
  })

}


export default __exports__